<template>
    <Header></Header>
    <Left></Left>
    <section class="container pdf_area_class">
        <div>
            <div class="area_title">
                <p v-if="state.mode">신규 상담</p>
                <p v-else="state.mode">내담자 상세</p>
                <div class="area_button" v-if="!state.mode">
                    <button type="button" @click="window.print()">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button>

                    <button type="button" @click="router.push({ name: 'supportCard', params: { id: state.idx } })">
                        <span>개별지원 통합카드</span>
                    </button>

                    <button type="button" @click="router.push({ name: 'counselListForClient', params: { id: state.data.idx } })">
                        <span>상담기록 확인</span>
                    </button>
                </div>
            </div>

            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>필수 입력 사항</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">초기 상담일</label></div>
                                <div class="area_col_body">
                                    <div class="datepicker">
                                        <input
                                            type="date"
                                            ref="strDate"
                                            :value="state.data.strDate"
                                            @change="onChangeDate"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">내담자 이름</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input
                                            type="text"
                                            class="w250"
                                            v-model="state.data.name"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">초기 상담원</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input
                                            type="text"
                                            class="w250"
                                            v-model="state.data.writer"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>담당 상담원</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <input
                                            type="text"
                                            class="w250"
                                            v-model="state.data.counselor"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>연번</label></div>
                                <div class="area_col_body">
                                    <div class="">
                                        <p v-text="state.data.number"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">초기 상담 유형</label></div>
                                <div class="area_col_body full">
                                    <div class="flex ac">
                                        <div class="select-wrap">
                                            <select
                                                v-model="state.data.counselType"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                class="w250"
                                            >
                                                <option v-for="item in CommonOptions.counselTypeList" :value="item.key">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="full">
                                            <input
                                                type="text"
                                                v-model="state.data.counselComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">기관인지 경로</label></div>
                                <div class="area_col_body full">
                                    <div class="flex ac">
                                        <div class="select-wrap">
                                            <select
                                                v-model="state.data.location"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                class="w250"
                                            >
                                                <option v-for="item in CommonOptions.locationList" :value="item.key">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="full">
                                            <input
                                                type="text"
                                                v-model="state.data.locationComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">상담 의뢰인</label></div>
                                <div class="area_col_body full">
                                    <div class="flex ac">
                                        <div class="select-wrap">
                                            <select
                                                v-model="state.data.introducer"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                class="w250"
                                            >
                                                <option v-for="item in CommonOptions.introducerList" :value="item.name">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="full">
                                            <input
                                                type="text"
                                                v-model="state.data.introducerComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">상담 부서</label></div>
                                <div class="area_col_body">
                                    <div class="select-wrap">
                                        <select
                                            class="w250"
                                            v-model="state.data.dept"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                            @change="
                                                state.data.consultDepartment =
                                                    CommonOptions.deptList.find((r) => r.key === state.data.dept)?.name ?? ''
                                            "
                                        >
                                            <option v-for="item in CommonOptions.deptList" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="area_form_foot">
                            <div class="area_button">
                                <template v-if="state.mode">
                                    <button type="button" @click="add('counsel')">등록 후 상담 기록으로 가기</button>
                                    <button type="button" @click="add('client')">등록 후 내담자 기록으로 가기</button>
                                    <button type="button" class="active" @click="add()">등록</button>
                                </template>
                                <template v-else>
                                    <template v-if="state.hasAuth === 1">
                                        <button type="button" @click="confirmModify('counselListForClient')">저장 후 상담 기록으로 가기</button>
                                        <button type="button" @click="confirmModify('client')">저장 후 내담자 기록으로 가기</button>
                                        <button type="button" class="active" @click="confirmModify()">저장</button>
                                    </template>
                                    <button
                                        v-else-if="state.hasAuth === -1 || state.hasAuth === 3"
                                        type="button"
                                        class="active"
                                        @click="showRequestAccessModal(1)"
                                    >
                                        수정 권한 요청
                                    </button>
                                    <button v-else-if="state.hasAuth === 0" type="button" class="gray" @click="">수정 승인 대기</button>
                                    <template v-else-if="state.hasAuth === 2">
                                        <button type="button" class="gray" @click="showRequestAccessModal(1)">수정 재승인 요청</button>
                                        <button type="button" class="blueBtn" @click="showRejectReason(state.modify.rejectReason)">반려 사유</button>
                                    </template>

                                    <template v-if="state.hasDeleteAuth === 1">
                                        <button type="button" class="danger" @click="confirmRemove()">삭제</button>
                                    </template>
                                    <button
                                        v-else-if="state.hasDeleteAuth === -1 || state.hasDeleteAuth === 3"
                                        type="button"
                                        class="danger"
                                        @click="showRequestAccessModal(2)"
                                    >
                                        삭제 권한 요청
                                    </button>
                                    <button v-else-if="state.hasDeleteAuth === 0" type="button" class="gray" @click="">삭제 승인 대기</button>
                                    <template v-else-if="state.hasDeleteAuth === 2">
                                        <button type="button" class="gray" @click="showRequestAccessModal(2)">삭제 재승인 요청</button>
                                        <button type="button" class="blueBtn" @click="showRejectReason(state.remove.rejectReason)">반려 사유</button>
                                    </template>
                                </template>

                                <template v-if="state.data.isCheck !== 1">
                                    <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify2">
                                        승인
                                    </button>

                                    <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify3">
                                        보완
                                    </button>
                                </template>
                            </div>

                            <template v-if="state.data.isCheck !== 1">
                                <div v-if="state.data.commentForTeamLeader" class="area_comment">
                                    <label>팀장 보완 요청</label>
                                    <div>
                                        <textarea v-model="state.data.commentForTeamLeader" disabled style="width: 100%; height: 150px"></textarea>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="container pdf_area_class">
        <div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>진행상황</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">진행상황</label></div>
                                <div class="area_col_row">
                                    <div class="area_col" style="justify-content: center">
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="state"
                                                        :checked="state.data.state === 1"
                                                        @click="state.data.state = 1"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>진행</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="state"
                                                        :checked="state.data.state === 3"
                                                        @click="state.data.state = 3"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>보류</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="state"
                                                        :checked="state.data.state === 2"
                                                        @click="state.data.state = 2"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>종결</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col" v-if="state.data.state === 1">
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="stateSub"
                                                        :checked="
                                                            state.data.stateSub === null || state.data.stateSub === '-' || state.data.stateSub === ''
                                                        "
                                                        @click="state.data.stateSub = ''"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>해당없음</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="stateSub"
                                                        :checked="state.data.stateSub === '긴급'"
                                                        @click="state.data.stateSub = '긴급'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>긴급</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="stateSub"
                                                        :checked="state.data.stateSub === '집중'"
                                                        @click="state.data.stateSub = '집중'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>집중</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="stateSub"
                                                        :checked="state.data.stateSub === '유지'"
                                                        @click="state.data.stateSub = '유지'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>유지</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="stateSub"
                                                        :checked="state.data.stateSub === '모니터링'"
                                                        @click="state.data.stateSub = '모니터링'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>모니터링</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="container pdf_area_class">
        <div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>기초자료</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_head"><label>성별</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="sex"
                                                :checked="state.data.clientDetailVO.sex === '' || state.data.clientDetailVO.sex === null"
                                                @click="state.data.clientDetailVO.sex = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="sex"
                                                :checked="state.data.clientDetailVO.sex === '여'"
                                                @click="state.data.clientDetailVO.sex = '여'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>여</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="sex"
                                                :checked="state.data.clientDetailVO.sex === '남'"
                                                @click="state.data.clientDetailVO.sex = '남'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>남</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="area_row">
                                <div class="area_col_head"><label>생년월일</label></div>
                                <div class="area_col_body">
                                    <p>{{ state.data.clientDetailVO.birth }}</p>
                                </div>
                            </div> -->

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>주민등록번호</label>
                                </div>
                                <div class="area_col_body">
                                    <div class="flex ac">
                                        <div class="">
                                            <input
                                                class="ss_input"
                                                placeholder="주민번호 앞자리"
                                                type="text"
                                                v-model="state.data.clientDetailVO.jumin1"
                                                @change="
                                                    state.data.clientDetailVO.jumin =
                                                        (state.data.clientDetailVO.jumin1 ?? '') + '-' + (state.data.clientDetailVO.jumin2 ?? '')
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="6"
                                            />
                                        </div>
                                        <span>-</span>
                                        <div class="">
                                            <input
                                                class="ss_input"
                                                placeholder="주민번호 뒷자리"
                                                type="text"
                                                v-model="state.data.clientDetailVO.jumin2"
                                                @change="
                                                    state.data.clientDetailVO.jumin =
                                                        (state.data.clientDetailVO.jumin1 ?? '') + '-' + (state.data.clientDetailVO.jumin2 ?? '')
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="7"
                                            />
                                        </div>
                                    </div>
                                    <div class="flex ac">
                                        <label>만 나이</label>
                                        <div class="">
                                            <input class="old_input" type="text" v-model="state.data.ageKor" :readonly="true" />
                                            세
                                        </div>
                                    </div>

                                    <div class="flex ac">
                                        <div class="checkbox_wrap flex ac">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    :checked="state.data.foreigner === 'Y'"
                                                    @click="
                                                        state.data.foreigner === 'Y' ? (state.data.foreigner = 'N') : (state.data.foreigner = 'Y')
                                                    "
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                                <em></em>
                                                <span>외국인</span>
                                            </label>
                                        </div>
                                        <div class="">
                                            <input
                                                placeholder="국적"
                                                type="text"
                                                v-model="state.data.foreignerDesc"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>주소</label></div>
                                <div class="area_col_row">
                                    <div class="area_col">
                                        <div class="area_col_head"><label>주민등록 상황</label></div>
                                        <div class="area_col_body full">
                                            <div class="">
                                                <input
                                                    placeholder="텍스트를 입력해주세요"
                                                    type="text"
                                                    v-model="state.data.clientDetailVO.juminAddress"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_head"><label>실거주지/ 주거상황</label></div>
                                        <div class="area_col_body full">
                                            <div class="">
                                                <input
                                                    placeholder="텍스트를 입력해주세요"
                                                    type="text"
                                                    v-model="state.data.clientDetailVO.address"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>현 주거사항</label></div>
                                <div class="area_col_row">
                                    <div class="area_col">
                                        <div class="area_col_head"><label>주거형태</label></div>
                                        <div class="area_col_body full">
                                            <div class="">
                                                <input
                                                    placeholder="텍스트를 입력해주세요"
                                                    type="text"
                                                    v-model="state.data.clientDetailVO.addressCurrent"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_head"><label>동거인</label></div>
                                        <div class="area_col_body">
                                            <div class="">
                                                <input
                                                    placeholder="텍스트를 입력해주세요"
                                                    type="text"
                                                    v-model="state.data.clientDetailVO.roommate"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>연락처</label></div>
                                <div class="area_col_body">
                                    <div class="flex ac ph_input_box">
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.phone1"
                                                @change="
                                                    state.data.clientDetailVO.phone =
                                                        state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="3"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.phone2"
                                                @change="
                                                    state.data.clientDetailVO.phone =
                                                        state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.phone3"
                                                @change="
                                                    state.data.clientDetailVO.phone =
                                                        state.data.clientDetailVO.phone1 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone2 +
                                                        '-' +
                                                        state.data.clientDetailVO.phone3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>
                                    </div>
                                    <div class="flex ac">
                                        <label>명의</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.phoneName"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>

                                    <div class="flex ac">
                                        <label>관계</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.phoneNameRel"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="area_row">
                                <div class="area_col_head"><label>집전화</label></div>
                                <div class="area_col_body">
                                    <div class="flex ac ph_input_box">
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.tel1"
                                                @change="
                                                    state.data.clientDetailVO.tel =
                                                        state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="3"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.tel2"
                                                @change="
                                                    state.data.clientDetailVO.tel =
                                                        state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.tel3"
                                                @change="
                                                    state.data.clientDetailVO.tel =
                                                        state.data.clientDetailVO.tel1 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel2 +
                                                        '-' +
                                                        state.data.clientDetailVO.tel3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>
                                    </div>
                                    <div class="flex ac">
                                        <label>명의</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telName"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>

                                    <div class="flex ac">
                                        <label>관계</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telNameRel"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>긴급연락처/ 관계</label></div>
                                <div class="area_col_body">
                                    <div class="flex ac ph_input_box">
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telEmergency1"
                                                @change="
                                                    state.data.clientDetailVO.telEmergency =
                                                        state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="3"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telEmergency2"
                                                @change="
                                                    state.data.clientDetailVO.telEmergency =
                                                        state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>

                                        <span>-</span>
                                        <div class="ph_input">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telEmergency3"
                                                @change="
                                                    state.data.clientDetailVO.telEmergency =
                                                        state.data.clientDetailVO.telEmergency1 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency2 +
                                                        '-' +
                                                        state.data.clientDetailVO.telEmergency3
                                                "
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                maxlength="4"
                                            />
                                        </div>
                                    </div>
                                    <div class="flex ac">
                                        <label>명의</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telEmergencyName"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>

                                    <div class="flex ac">
                                        <label>관계</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.clientDetailVO.telEmergencyNameRel"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>이메일, SNS</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input
                                            placeholder="텍스트를 입력해주세요"
                                            type="text"
                                            v-model="state.data.clientDetailVO.email"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row page_avoid">
                                <div class="area_col_head"><label>성매매 지역</label></div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="flex ac">
                                                <div class="">
                                                    <select
                                                        class="w150"
                                                        v-model="state.data.area1"
                                                        @change="
                                                            state.data.area1 !== '광역시' && state.data.area1 !== '각 도별'
                                                                ? (state.data.area = state.data.area1)
                                                                : (state.data.area = '')
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    >
                                                        <option v-for="item in CommonOptions.area1List" :value="item.name">{{ item.name }}</option>
                                                    </select>
                                                </div>

                                                <div
                                                    class=""
                                                    v-if="state.data.area1 === '서울' || (state.data.area1 && state.data.area1.indexOf('서울') > -1)"
                                                >
                                                    <select
                                                        class="w250"
                                                        v-model="state.data.area4"
                                                        @change="state.data.area = state.data.area4"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    >
                                                        <option v-for="item in CommonOptions.area4List" :value="item.name">{{ item.name }}</option>
                                                    </select>
                                                </div>

                                                <div
                                                    class=""
                                                    v-if="
                                                        state.data.area1 === '광역시' || (state.data.area1 && state.data.area1.indexOf('광역시') > -1)
                                                    "
                                                >
                                                    <select
                                                        class="w250"
                                                        v-model="state.data.area2"
                                                        @change="state.data.area = state.data.area2"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    >
                                                        <option v-for="item in CommonOptions.area2List" :value="item.name">{{ item.name }}</option>
                                                    </select>
                                                </div>

                                                <div
                                                    class=""
                                                    v-if="state.data.area1 === '각 도별' || (state.data.area1 && state.data.area1.indexOf('도') > -1)"
                                                >
                                                    <select
                                                        class="w250"
                                                        v-model="state.data.area3"
                                                        @change="state.data.area = state.data.area3"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    >
                                                        <option v-for="item in CommonOptions.area3List" :value="item.name">{{ item.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_body textarea_wrap">
                                            <textarea
                                                placeholder="기타"
                                                v-model="state.data.areaComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            ></textarea>

                                            <p v-text="state.data.areaComment"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>성매매 유형</label></div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="">
                                                <select
                                                    class="w150"
                                                    v-model="state.data.type"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                >
                                                    <option v-for="item in CommonOptions.typeList" :value="item.key">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_body textarea_wrap">
                                            <textarea
                                                placeholder="기타"
                                                v-model="state.data.typeComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            ></textarea>

                                            <p v-text="state.data.typeComment"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>선불액수</label></div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="">
                                                <select
                                                    class="w150"
                                                    v-model="state.data.price"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                >
                                                    <option v-for="item in CommonOptions.priceList" :value="item.key">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_body textarea_wrap">
                                            <textarea
                                                placeholder="기타"
                                                v-model="state.data.priceComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            ></textarea>

                                            <p v-text="state.data.priceComment"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>알선고리</label></div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="">
                                                <select
                                                    class="w150"
                                                    v-model="state.data.broker"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                >
                                                    <option v-for="item in CommonOptions.brokerList" :value="item.key">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_body textarea_wrap">
                                            <textarea
                                                placeholder="기타"
                                                v-model="state.data.brokerComment"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            ></textarea>

                                            <p v-text="state.data.brokerComment"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>유입시기</label></div>
                                <div class="area_col_body">
                                    <div class="flex ac">
                                        <label>연도</label>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.historyYear"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                class="year_input"
                                            />
                                        </div>
                                        <span>년</span>
                                    </div>
                                    <div class="flex ac">
                                        <span>당시 나이</span>
                                        <div class="">
                                            <input
                                                type="text"
                                                v-model="state.data.historyAge"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                class="old_input"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>장애진단여부</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="isHuddle"
                                                :checked="state.data.isHurdles === ''"
                                                @click="state.data.isHurdles = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isHuddle"
                                                :checked="state.data.isHurdles === 1"
                                                @click="state.data.isHurdles = 1"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>있음</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isHuddle"
                                                :checked="state.data.isHurdles === 0"
                                                @click="state.data.isHurdles = 0"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>없음</span>
                                        </label>
                                    </div>

                                    <div class="full">
                                        <input
                                            type="text"
                                            placeholder="기타"
                                            v-model="state.data.isHurdlesComment"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>장애유형</label></div>
                                <div class="area_col_row">
                                    <div class="area_col">
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === ''"
                                                        @click="state.data.hurdlesType = ''"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>선택안함</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '없음'"
                                                        @click="state.data.hurdlesType = '없음'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>없음</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_head"><label>추정</label></div>
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '지적장애(추정)'"
                                                        @click="state.data.hurdlesType = '지적장애(추정)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>지적장애</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '정신장애(추정)'"
                                                        @click="state.data.hurdlesType = '정신장애(추정)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>정신장애</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '신체장애(추정)'"
                                                        @click="state.data.hurdlesType = '신체장애(추정)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>신체장애</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_head"><label>등록</label></div>
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '지적장애(등록)'"
                                                        @click="state.data.hurdlesType = '지적장애(등록)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>지적장애</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '정신장애(등록)'"
                                                        @click="state.data.hurdlesType = '정신장애(등록)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>정신장애</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="hurdlesType"
                                                        :checked="state.data.hurdlesType === '신체장애(등록)'"
                                                        @click="state.data.hurdlesType = '신체장애(등록)'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>신체장애</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>수급유형</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="hurdlesReceive"
                                                :checked="state.data.hurdlesReceive === ''"
                                                @click="state.data.hurdlesReceive = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="hurdlesReceive"
                                                :checked="state.data.hurdlesReceive === '수급자'"
                                                @click="state.data.hurdlesReceive = '수급자'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>수급자</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="hurdlesReceive"
                                                :checked="state.data.hurdlesReceive === '일반'"
                                                @click="state.data.hurdlesReceive = '일반'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>일반</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>학력</label></div>
                                <div class="area_col_body full">
                                    <div class="flex ac">
                                        <div class="select-wrap">
                                            <select
                                                v-model="state.data.clientDetailVO.historySchool"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            >
                                                <option v-for="item in CommonOptions.schoolHistoryList" :value="item.key">{{ item.name }}</option>
                                            </select>
                                        </div>

                                        <div class="full">
                                            <input
                                                type="text"
                                                name="historySchoolDesc"
                                                v-model="state.data.clientDetailVO.historySchoolDesc"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>가출경험유무</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="isRunaway"
                                                :checked="state.data.isRunaway === ''"
                                                @click="state.data.isRunaway = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isRunaway"
                                                :checked="state.data.isRunaway === '있음'"
                                                @click="state.data.isRunaway = '있음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>있음</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isRunaway"
                                                :checked="state.data.isRunaway === '없음'"
                                                @click="state.data.isRunaway = '없음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>없음</span>
                                        </label>
                                    </div>

                                    <div class="full">
                                        <input
                                            type="text"
                                            placeholder="기타"
                                            name="isRunawayComment"
                                            v-model="state.data.isRunawayComment"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>처음 가출한 시기</label></div>

                                <div class="area_col_row">
                                    <div class="area_col">
                                        <div class="area_col_head"><label>학교</label></div>
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="historySchool"
                                                        :checked="state.data.firstRunawayDate === ''"
                                                        @click="state.data.firstRunawayDate = ''"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>선택안함</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="historySchool"
                                                        :checked="state.data.firstRunawayDate === '초등학교'"
                                                        @click="state.data.firstRunawayDate = '초등학교'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>초등학교</span>
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="historySchool"
                                                        :checked="state.data.firstRunawayDate === '중학교'"
                                                        @click="state.data.firstRunawayDate = '중학교'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>중학교</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="historySchool"
                                                        :checked="state.data.firstRunawayDate === '고등학교'"
                                                        @click="state.data.firstRunawayDate = '고등학교'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>고등학교</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="historySchool"
                                                        :checked="state.data.firstRunawayDate === '성인'"
                                                        @click="state.data.firstRunawayDate = '성인'"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>성인</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_head"><label>가출한 나이</label></div>
                                        <div class="area_col_body">
                                            <div class="flex ac">
                                                <div class="">
                                                    <input
                                                        class="old_input"
                                                        type="text"
                                                        v-model="state.data.runawayAge"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                </div>

                                                <span>세</span>
                                            </div>
                                            <div class="flex ac">
                                                <div class="">
                                                    <span>연도</span>
                                                    <input
                                                        class="year_input"
                                                        type="text"
                                                        v-model="state.data.runawayYear"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                </div>
                                                <span>년</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>성폭력 유무</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="isSexualViolence"
                                                :checked="state.data.isSexualViolence === ''"
                                                @click="state.data.isSexualViolence = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isSexualViolence"
                                                :checked="state.data.isSexualViolence === '있음'"
                                                @click="state.data.isSexualViolence = '있음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>있음</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isSexualViolence"
                                                :checked="state.data.isSexualViolence === '없음'"
                                                @click="state.data.isSexualViolence = '없음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>없음</span>
                                        </label>
                                    </div>

                                    <div class="flex ac">
                                        <span>횟수</span>
                                        <input
                                            type="text"
                                            name="cntSexualViolence"
                                            v-model="state.data.cntSexualViolence"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>혼인 여부</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === null"
                                                @click="state.data.clientDetailVO.marriageType = null"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === '3'"
                                                @click="state.data.clientDetailVO.marriageType = '3'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>미혼</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === '2'"
                                                @click="state.data.clientDetailVO.marriageType = '2'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>동거</span>
                                        </label>

                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === '4'"
                                                @click="state.data.clientDetailVO.marriageType = '4'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>이혼</span>
                                        </label>

                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === '5'"
                                                @click="state.data.clientDetailVO.marriageType = '5'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>혼인중</span>
                                        </label>

                                        <label>
                                            <input
                                                type="radio"
                                                name="marriageType"
                                                :checked="state.data.clientDetailVO.marriageType === '1'"
                                                @click="state.data.clientDetailVO.marriageType = '1'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>기타</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>가정폭력 유무</label></div>
                                <div class="area_col_body">
                                    <div class="radio_wrap">
                                        <label>
                                            <input
                                                type="radio"
                                                name="isViolence"
                                                :checked="state.data.isViolence === ''"
                                                @click="state.data.isViolence = ''"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>선택안함</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isViolence"
                                                :checked="state.data.isViolence === '있음'"
                                                @click="state.data.isViolence = '있음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>있음</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="isViolence"
                                                :checked="state.data.isViolence === '없음'"
                                                @click="state.data.isViolence = '없음'"
                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                            />
                                            <em></em>
                                            <span>없음</span>
                                        </label>
                                    </div>

                                    <div class="full">
                                        <input
                                            type="text"
                                            placeholder="기타"
                                            name="isViolenceComment"
                                            v-model="state.data.isViolenceComment"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>가족관계</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input
                                            placeholder="텍스트를 입력해주세요"
                                            type="text"
                                            name="family"
                                            v-model="state.data.family"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>자녀 여부</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input
                                            placeholder="텍스트를 입력해주세요"
                                            type="text"
                                            name="hasChild"
                                            v-model="state.data.clientDetailVO.hasChild"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>
                                        성매매 유입
                                        <br />
                                        및 이동경로
                                    </label>
                                </div>
                                <div class="area_col_body">
                                    <div class="textarea_wrap">
                                        <textarea
                                            placeholder="- 성매매 종사시기
- 유입에서 현재에 이르기까지의 종사유형, 업소경유 구체적으로
- 마지막 업소 일한 현황 및 업소 나오게 된 경위"
                                            v-model="state.data.sexualViolenceLocation"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        ></textarea>

                                        <p v-text="state.data.sexualViolenceLocation"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>상담 내용</label></div>
                                <div class="area_col_body no_padding">
                                    <div class="area_col_row">
                                        <div class="area_row">
                                            <div class="area_col_head w150">
                                                <label>
                                                    성매매관련 피해
                                                    <p>(업소/ 소개소/ 사채/ 맞보증/ 보험/ 계/ 굿/ 성형 등 연결 현황)</p>
                                                </label>
                                            </div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="텍스트를 입력해 주세요."
                                                        v-model="state.data.sexualViolenceVictims"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.sexualViolenceVictims"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="area_row">
                                            <div class="area_col_head w150">
                                                <label>
                                                    관련 사건체크
                                                    <p>(지원받은 경력)</p>
                                                    현재 집형 사건
                                                    <p>(전과기록 등)</p>
                                                </label>
                                            </div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="텍스트를 입력해 주세요."
                                                        v-model="state.data.sexualViolenceCase"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.sexualViolenceCase"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="area_row">
                                            <div class="area_col_head w150">
                                                <label>
                                                    신변안전상태
                                                    <p>(위협/ 협박 등)</p>
                                                </label>
                                            </div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="텍스트를 입력해 주세요."
                                                        v-model="state.data.safetyStatus"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.safetyStatus"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="area_row">
                                            <div class="area_col_head w150"><label>법률지원</label></div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="- 법원/ 사건번호:
- 검/ 경 담당부서, 담당자:."
                                                        v-model="state.data.supportLegal"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.supportLegal"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="area_row">
                                            <div class="area_col_head w150"><label>의료지원</label></div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="- 건강상태:
- 장애진단:
- 약물복용:
- 자살시도:
- 정신건강:"
                                                        v-model="state.data.supportMedical"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.supportMedical"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="area_row">
                                            <div class="area_col_head w150"><label>자활지원</label></div>
                                            <div class="area_col_body">
                                                <div class="textarea_wrap">
                                                    <textarea
                                                        placeholder="텍스트를 입력해 주세요."
                                                        v-model="state.data.supportSelfReliance"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    ></textarea>

                                                    <p v-text="state.data.supportSelfReliance"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>면접자 의견</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input
                                            type="text"
                                            name="comment"
                                            v-model="state.data.comment"
                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        :path="state.path"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        CommonForms,
        useRoute,
        ref,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();
            const today = new Date();

            const route = useRoute();

            const state = reactive({
                mode: true as boolean, // true: insert, false: update
                hasAuth: -1 as -1 | 0 | 1 | 2 | 3 | 4, // 0: 대기, 1: 승인, 2: 반려, 3: 수정완료, 4: 처리완료
                hasDeleteAuth: -1 as -1 | 0 | 1 | 2 | 3 | 4, // 0: 대기, 1: 승인, 2: 반려, 3: 수정완료, 4: 처리완료

                modify: {} as any,
                remove: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                gubun: 1 as 1 | 2 | 3 | 4,
                path: "" as string,

                idx: 0 as number,

                data: {
                    strDate: "" as string,
                    area1: "" as string,
                    area2: "" as string,
                    area3: "" as string,

                    phone1: "" as string,
                    phone2: "" as string,
                    phone3: "" as string,

                    tel1: "" as string,
                    tel2: "" as string,
                    tel3: "" as string,

                    telEmergency1: "" as string,
                    telEmergency2: "" as string,
                    telEmergency3: "" as string,

                    clientDetailVO: {
                        sex: "" as string,
                        jumin1: "" as string,
                        jumin2: "" as string,
                    } as types.client.ClientDetailVOForApi | any,
                    isCheck: 0 as number,
                } as types.client.ClientVOForApi | any,
            });

            onMounted(async () => {
                if (route.params.id) {
                    state.idx = Number(route.params.id);
                    state.mode = false;

                    await detail();

                    if (state.data != null) {
                        if (state.data.isCheck !== 1 || CommonUtils.checkAuth() || (user.userInfo.auth === 5 && state.data.dept === 4)) {
                            state.hasAuth = 1;
                            state.hasDeleteAuth = 1;
                        } else {
                            getAccessRequestForTarget();
                        }
                    }
                } else {
                    state.mode = true;

                    state.data = {
                        strDate: "" as string,
                        area1: "" as string,
                        area2: "" as string,
                        area3: "" as string,
                        phone1: "" as string,
                        phone2: "" as string,
                        phone3: "" as string,
                        tel1: "" as string,
                        tel2: "" as string,
                        tel3: "" as string,
                        telEmergency1: "" as string,
                        telEmergency2: "" as string,
                        telEmergency3: "" as string,
                        clientDetailVO: {
                            sex: "" as string,
                            jumin1: "" as string,
                            jumin2: "" as string,
                        } as types.client.ClientDetailVOForApi | any,
                        writer: user.userInfo.name as string,
                        counselor: user.userInfo.name as string,
                    };
                    state.data.strDate = CommonUtils.getToday("");

                    if (user.userInfo.auth === 5) state.data.dept = 4;
                }
            });

            watch(
                () => route.params.id,
                () => {
                    if (route.params.id) {
                        state.idx = Number(route.params.id);
                        state.mode = false;

                        detail();
                        if (state.data.isCheck !== 1 || CommonUtils.checkAuth() || (user.userInfo.auth === 5 && state.data.dept === 4)) {
                            state.hasAuth = 1;
                            state.hasDeleteAuth = 1;
                        } else {
                            getAccessRequestForTarget();
                        }
                    } else {
                        state.mode = true;
                        state.data = {
                            strDate: "" as string,
                            area1: "" as string,
                            area2: "" as string,
                            area3: "" as string,
                            phone1: "" as string,
                            phone2: "" as string,
                            phone3: "" as string,
                            tel1: "" as string,
                            tel2: "" as string,
                            tel3: "" as string,
                            telEmergency1: "" as string,
                            telEmergency2: "" as string,
                            telEmergency3: "" as string,
                            clientDetailVO: {
                                sex: "" as string,
                                jumin1: "" as string,
                                jumin2: "" as string,
                            } as types.client.ClientDetailVOForApi | any,
                            writer: user.userInfo.name as string,
                            counselor: user.userInfo.name as string,
                        };
                        state.data.strDate = CommonUtils.getToday("");

                        if (user.userInfo.auth === 5) state.data.dept = 4;
                    }
                },
            );

            watch(
                () => [state.data.clientDetailVO.jumin1, state.data.clientDetailVO.jumin2],
                () => {
                    if (state.data.clientDetailVO.jumin1 && state.data.clientDetailVO.jumin2) {
                        let frontNumber = 19;
                        if (["1", "2"].includes(state.data.clientDetailVO.jumin2.charAt(0))) frontNumber = 19;
                        else frontNumber = 20;
                        const ageKor = CommonUtils.getManAge(frontNumber + "" + state.data.clientDetailVO.jumin1);

                        if (ageKor) state.data.ageKor = ageKor;
                        // console.info(ageKor);
                    } else {
                        state.data.ageKor = null;
                    }
                },
            );

            const strDate = ref();
            const onChangeDate = (e: any) => {
                const newDate = e.target.value;
                state.data.strDate = newDate;
                strDate.value = newDate;
            };

            const reset = () => {
                Object.assign(state.data, CommonForms.clientForm);
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "requestAccess") {
                    requestAccess(param.gubun, param.content);
                } else if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify(param.path);
                            break;
                        case 2:
                            remove();
                            break;
                        case 3:
                            confirmByTeamLeader(1);
                            break;
                        case 4:
                            confirmByTeamLeader(2, param.content);
                            break;
                    }
                } else if (param.action === "callback") {
                    if (param.gubun === 1) {
                        if (param.path) {
                            router.push({ name: param.path, params: { id: state.idx } });
                        } else {
                            state.isShowModal = false;
                            detail();
                        }
                    } else if (param.gubun === 2) {
                        if (param.path) {
                            router.push({ name: param.path });
                        } else {
                            router.back();
                        }
                    } else {
                        state.isShowModal = false;
                    }
                }
            };

            const detail = async () => {
                const res: types.client.ResClient = await apiService.client.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                    state.data.strDate = CommonUtils.dateFormatYYYYMMDD(state.data.date, "-");

                    strDate.value = state.data.strDate;
                    if (state.data.clientDetailVO.jumin && state.data.clientDetailVO.jumin.indexOf("-") > -1) {
                        state.data.clientDetailVO.jumin1 = state.data.clientDetailVO.jumin.split("-")[0];
                        state.data.clientDetailVO.jumin2 = state.data.clientDetailVO.jumin.split("-")[1];
                    } else if (state.data.clientDetailVO.jumin) {
                        state.data.clientDetailVO.jumin1 = state.data.clientDetailVO.jumin.substring(0, 6);
                        state.data.clientDetailVO.jumin2 = state.data.clientDetailVO.jumin.substring(6, 13);
                    }

                    if (state.data.clientDetailVO.phone) {
                        if (state.data.clientDetailVO.phone.indexOf("-") > -1) {
                            state.data.clientDetailVO.phone1 = state.data.clientDetailVO.phone.split("-")[0];
                            state.data.clientDetailVO.phone2 = state.data.clientDetailVO.phone.split("-")[1];
                            state.data.clientDetailVO.phone3 = state.data.clientDetailVO.phone.split("-")[2];
                        } else {
                            const phone = CommonUtils.convertPhoneNum(state.data.clientDetailVO.phone);
                            state.data.clientDetailVO.phone1 = phone.split("-")[0];
                            state.data.clientDetailVO.phone2 = phone.split("-")[1];
                            state.data.clientDetailVO.phone3 = phone.split("-")[2];
                        }
                    }

                    if (state.data.clientDetailVO.tel) {
                        if (state.data.clientDetailVO.tel.indexOf("-") > -1) {
                            state.data.clientDetailVO.tel1 = state.data.clientDetailVO.tel.split("-")[0];
                            state.data.clientDetailVO.tel2 = state.data.clientDetailVO.tel.split("-")[1];
                            state.data.clientDetailVO.tel3 = state.data.clientDetailVO.tel.split("-")[2];
                        } else {
                            const phone = CommonUtils.convertPhoneNum(state.data.clientDetailVO.tel);

                            state.data.clientDetailVO.tel1 = phone.split("-")[0];
                            state.data.clientDetailVO.tel2 = phone.split("-")[1];
                            state.data.clientDetailVO.tel3 = phone.split("-")[2];
                        }
                    }

                    if (state.data.clientDetailVO.telEmergency) {
                        if (state.data.clientDetailVO.telEmergency.indexOf("-") > -1) {
                            state.data.clientDetailVO.telEmergency1 = state.data.clientDetailVO.telEmergency.split("-")[0];
                            state.data.clientDetailVO.telEmergency2 = state.data.clientDetailVO.telEmergency.split("-")[1];
                            state.data.clientDetailVO.telEmergency3 = state.data.clientDetailVO.telEmergency.split("-")[2];
                        } else {
                            const phone = CommonUtils.convertPhoneNum(state.data.clientDetailVO.telEmergency);
                            state.data.clientDetailVO.telEmergency1 = phone.split("-")[0];
                            state.data.clientDetailVO.telEmergency2 = phone.split("-")[1];
                            state.data.clientDetailVO.telEmergency3 = phone.split("-")[2];
                        }
                    }

                    if (state.data.area) {
                        if (state.data.area === "기록없음" || state.data.area === "외국") state.data.area1 = state.data.area;
                        else if (state.data.area.indexOf("도") > -1) {
                            state.data.area1 = "각 도별";
                            state.data.area3 = state.data.area;
                        } else if (state.data.area.indexOf("광역시") > -1) {
                            state.data.area1 = "광역시";
                            state.data.area2 = state.data.area;
                        } else {
                            state.data.area1 = "서울";
                            state.data.area4 = state.data.area;
                        }
                    }

                    if (state.data.clientDetailVO.birth) {
                        state.data.ageKor = CommonUtils.getManAge(state.data.clientDetailVO.birth);
                    } else {
                        state.data.ageKor = null;
                    }
                } else {
                    state.data = null;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getAccessRequestForTarget = async () => {
                const res: types.accessRequest.ResAccessRequestForTarget = await apiService.accessRequest.detailForTarget(1, Number(route.params.id));
                if (res.returnCode === 0) {
                    const modify = res.modify;
                    if (modify && modify.state > -1) {
                        state.hasAuth = modify.state;
                        state.modify = modify;
                    }

                    const remove = res.remove;
                    if (remove && remove.state > -1) {
                        state.hasDeleteAuth = remove.state;
                        state.remove = remove;
                    }
                } else {
                    state.hasAuth = -1;
                    state.hasDeleteAuth = -1;
                }
            };

            const add = async (path?: string) => {
                if (!state.data.strDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담일을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.name) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "내담자 이름을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.writer) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담원을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.counselType) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담 유형을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.location) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "기관인지 경로를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.introducer) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 의뢰인을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.dept) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 부서를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.state) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "진행상황을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.client.ReqClient = state.data;
                    Object.assign(param, state.data.clientDetailVO);

                    if (state.data.clientDetailVO.phone) param.phone = state.data.clientDetailVO.phone.replaceAll("-", "");
                    if (state.data.clientDetailVO.tel) param.tel = state.data.clientDetailVO.tel.replaceAll("-", "");
                    if (state.data.clientDetailVO.telEmergency) param.telEmergency = state.data.clientDetailVO.telEmergency.replaceAll("-", "");
                    param.date = Number(state.data.strDate.replaceAll("-", ""));
                    const res = await apiService.client.add(param);
                    if (res.returnCode === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "등록되었습니다.";
                        state.isShowModal = true;
                        state.gubun = 2;
                        if (path) state.path = path;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const confirmModify = (path?: string) => {
                if (state.data.strDate) {
                    state.modalTab = 1;
                    state.modalContent = "정말 변경하시겠습니까?";
                } else {
                    state.modalTab = -1;
                    state.modalContent = "초기 상담일을 작성해주세요";
                }
                state.modalTitle = "알림";
                state.isShowModal = true;
                state.gubun = 1;
                if (path) state.path = path;
            };

            const confirmModify2 = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 승인하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };

            const confirmModify3 = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 보완하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 4;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const modify = async (path?: string) => {
                if (!state.data.strDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담일을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.name) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "내담자 이름을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.writer) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담원을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.counselType) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "초기 상담 유형을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.location) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "기관인지 경로를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.introducer) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 의뢰인을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.dept) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 부서를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.state) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "진행상황을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.client.ReqClient = state.data;
                    Object.assign(param, state.data.clientDetailVO);

                    if (state.data.clientDetailVO.phone) param.phone = state.data.clientDetailVO.phone.replaceAll("-", "");
                    if (state.data.clientDetailVO.tel) param.tel = state.data.clientDetailVO.tel.replaceAll("-", "");
                    if (state.data.clientDetailVO.telEmergency) param.telEmergency = state.data.clientDetailVO.telEmergency.replaceAll("-", "");
                    param.date = Number(state.data.strDate.replaceAll("-", ""));
                    const res = await apiService.client.modify(Number(route.params.id), param);
                    if (res.returnCode === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "수정되었습니다.";
                        state.isShowModal = true;
                        state.gubun = 1;
                        if (path) state.path = path;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const remove = async () => {
                const res = await apiService.client.remove(Number(route.params.id));
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 2;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmByTeamLeader = async (numState: number, content?: string) => {
                const comment = content ? content : "";
                const res = await apiService.client.checkForTeamLeader(state.idx, numState, comment);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "저장되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 1;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const showRequestAccessModal = (gubun: 1 | 2) => {
                state.modalTab = 2;
                state.modalTitle = gubun === 1 ? "수정 권한 요청" : "삭제 권한 요청";
                state.isShowModal = true;
                state.gubun = gubun;
            };

            const requestAccess = async (gubun: 1 | 2, reason: string) => {
                const param: types.accessRequest.ReqAccessRequest = {
                    type: 1,
                    gubun: gubun,
                    targetIdx: state.idx,
                    dept: state.data!.dept,
                    reason: reason,
                };
                const res = await apiService.accessRequest.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "권한을 요청하였습니다. <br> 관리자 승인 후, 가능합니다.";
                    state.isShowModal = true;

                    getAccessRequestForTarget();
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const showRejectReason = (reason: string) => {
                state.modalTab = -1;
                state.modalTitle = "반려 사유";
                state.modalContent = reason.replaceAll("\n", "<br>");
                state.isShowModal = true;
            };

            return {
                state,
                router,
                reset,
                CommonUtils,
                CommonOptions,
                closeModal,
                callBackModal,
                add,
                showRequestAccessModal,
                confirmModify,
                confirmModify2,
                confirmModify3,
                confirmRemove,
                window,
                showRejectReason,
                onChangeDate,
            };
        },
    };
</script>
<style scoped>
    input:disabled,
    select:disabled,
    textarea:disabled,
    button:disabled,
    input:disabled + em {
        cursor: no-drop;
    }
</style>
